import Canceled, { getSuccessLink } from './Canceled';

export {
  getSuccessLink,
};
export default Canceled;
